import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { css, cx } from "styled-system/css";

const markdownStyles = css({
  color: "text.dark",
  fontSize: "sm",
  lineHeight: "1.6",
  wordBreak: "break-word",
  "& > :first-child": { mt: "0" },
  "& > :last-child": { mb: "0" },
  "& h1": { fontSize: "xl", fontWeight: "semibold", mt: "400", mb: "200" },
  "& h2": { fontSize: "lg", fontWeight: "semibold", mt: "400", mb: "150" },
  "& h3": { fontSize: "md", fontWeight: "semibold", mt: "300", mb: "100" },
  "& h4, & h5, & h6": { fontSize: "sm", fontWeight: "semibold", mt: "200", mb: "100" },
  "& p": { my: "150" },
  "& ul, & ol": { pl: "400", my: "150" },
  "& ul": { listStyleType: "disc" },
  "& ol": { listStyleType: "decimal" },
  "& li": { my: "50" },
  "& li > input[type=checkbox]": { mr: "100" },
  "& a": { color: "text.accent.blue.mid", textDecoration: "underline" },
  "& code": {
    fontFamily: "mono",
    fontSize: "xs",
    bg: "bg.wa.light",
    px: "50",
    borderRadius: "50",
  },
  "& pre": {
    bg: "bg.wa.light",
    p: "200",
    borderRadius: "100",
    overflowX: "auto",
    my: "200",
    "& code": { bg: "transparent", px: "0" },
  },
  "& blockquote": {
    borderLeftWidth: "3px",
    borderColor: "border.light",
    pl: "200",
    color: "text.mid",
    my: "200",
  },
  "& table": { borderCollapse: "collapse", my: "200", fontSize: "xs", display: "block", overflowX: "auto" },
  "& th, & td": { borderWidth: "1px", borderColor: "border.light", px: "100", py: "50", textAlign: "left" },
  "& hr": { my: "300", borderColor: "border.light" },
});

const articleStyles = css({
  fontSize: "md",
  maxW: "720px",
  "& h1": { fontSize: "2xl" },
});

type WorkbenchMarkdownProps = {
  children: string;
  variant?: "plan" | "article" | "chat";
  className?: string;
};

export const WorkbenchMarkdown = ({
  children,
  variant = "plan",
  className,
}: WorkbenchMarkdownProps) => (
  <div
    className={cx(
      markdownStyles,
      variant === "article" && articleStyles,
      className,
    )}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children: linkChildren }) => (
          <a href={href} target="_blank" rel="noreferrer">
            {linkChildren}
          </a>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  </div>
);
